// Compose the "Featured" strip from two sources:
//   - recs: recommender output (recipes similar to what you've reviewed/liked)
//   - followedPick: one recent recipe from someone you follow (or null)
// Layout is `count` cards total, reserving `followSlots` for the followed pick
// (so the default is 2 recommender + 1 followed). Dedupes by id, and if there
// is no followed pick (you follow no one yet, etc.) the slot is filled from
// the recommender so Featured always stays full. Pure + deterministic.
export function composeFeatured(recs = [], followedPick = null, count = 3, followSlots = 1) {
  const recSlots = count - (followedPick ? followSlots : 0);
  const out = [];
  const seen = new Set();
  const push = (r) => {
    if (r && r.id && !seen.has(r.id) && out.length < count) {
      out.push(r);
      seen.add(r.id);
    }
  };

  // Recommender picks first...
  for (const r of recs) {
    if (out.length >= recSlots) break;
    push(r);
  }
  // ...then the followed pick...
  if (followedPick) push(followedPick);
  // ...then backfill any remaining slots from the recommender.
  for (const r of recs) push(r);

  return out.slice(0, count);
}
